// Fila de KPIs — tarjetas pequeñas con etiqueta arriba y valor grande abajo.
//
// Uso:
//   const node = kpiRow([
//     { label: 'Volumen', value: '42 m³' },
//     { label: 'Total', value: '512 €', gold: true },
//   ]);

export function kpiRow(items) {
  const wrap = document.createElement('div');
  wrap.className = 'kpi-row';
  for (const item of items) {
    const k = document.createElement('div');
    k.className = 'kpi';
    k.innerHTML = `
      <div class="kpi__label">${escapeHtml(item.label)}</div>
      <div class="kpi__value${item.gold ? ' kpi__value--gold' : ''}">${escapeHtml(item.value)}</div>
    `;
    wrap.appendChild(k);
  }
  return wrap;
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
